<template>
	<div id="toptitle">
		<div class="left"><img src="@/assets/fanhui.png" @click="goBack" v-if="isShowBack"></div>
		<div class="title">{{title}}</div>
		<div class="right"></div>
	</div>
</template>
<style lang="scss" scoped>
	#toptitle {
		width: 100%;
		max-width: 750px;
		min-width: 320px;
		height: 100px;
		background: #109FC7;
		padding: 0 40px;
		box-sizing: border-box;
		position: fixed;
		z-index: 9999;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		display: flex;
		justify-content: space-between;
		align-items: center;

		.title {
			text-align: center;
			color: #fff;
			font-size: 34px;
			line-height: 100px;
			letter-spacing: 4px;
		}

		.left {
			z-index: 999;
			width: 32px;
			height: 32px;

			img {
				width: 32px;
				height: 32px;
			}
		}

		.right {
			width: 32px;
			height: 32px;
		}
	}
</style>

<script>
	export default {
		name: 'Toptitle',
		data() {
			return {

			}
		},
		methods: {
			// 点击后退
			goBack() {
				if (window.history.length <= 1) {
					this.$router.push({
						name: 'Index',
					})
					return false
				} else {
					this.$router.go(-1)
				}
				console.log(this.$router);
				// this.$router.go(-1);
			},
		},
		created() {
			// 根据路由确定是否显示返回按钮  tabar页面不显示 其余显示
			// if (this.$route.path === '/home/index'||this.$route.path === '/home/yyjj'||this.$route.path === '/home/activity') {
			// 	this.isShowBack = false;
			// } else {
			// 	this.isShowBack = true;
			// }


		},
		watch: {
			// 监听路由 确定是否显示返回按钮
			// "$route.path": function(newVal) {
			// 	if (newVal === '/home/index'||newVal === '/home/yyjj'||newVal === '/home/activity') {
			// 		this.isShowBack = false;
			// 	} else {
			// 		this.isShowBack = true;
			// 	}
			// }
		},
		props: {
			title: { //中间title
				type: String,
				default: "成都西部甲状腺医院挂号平台"
			},
			isShowBack: { //是否显示返回按钮
				type: Boolean,
				default: false

			}
		}
	};
</script>
